<template>
    <div class="solution-inquiry">
        <div class="inquiry">
            <span class="close-btn" @click="closeInquiry()">
                <svg class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.701 19.701"><g transform="translate(-1663.3 -284.3)"><path d="M10.746,9.878,19.7,18.833l-.868.868L9.878,10.746.868,19.7,0,18.833,8.955,9.878,0,.868.868,0,9.823,8.955,18.833,0,19.7.868Z" transform="translate(1663.3 284.3)"/></g></svg>
            </span>
            <h4>Искате подобен проект?</h4>
            <span>Попълнете вашите детайли</span>
            <div class="inquiry-form" v-if="!isSent">
                <div class="inquiry-form-row">
                    <div class="inquiry-input">
                        <label for="inquiryName" v-if="isNameValid">Вашето име</label>
                        <label for="inquiryName" v-else :class="{ 'not-valid' : !isNameValid }">Вашето име е задължително</label>
                        <input type="text" id="inquiryName" :class="{ 'not-valid-border' : !isNameValid }" v-model="request.name">
                    </div>
                    <div class="inquiry-input">
                        <label for="inquiryEmail" v-if="isEmailValid" >e-mail</label>
                        <label for="inquiryEmail" v-else :class="{ 'not-valid' : !isEmailValid }">e-mail-а е задължителен</label>
                        <input type="text" id="inquiryEmail" :class="{ 'not-valid-border' : !isEmailValid }" v-model="request.email">
                    </div>
                    <div class="inquiry-input">
                        <label for="inquiryPhone" v-if="isPhoneValid">Телефон</label>
                        <label for="inquiryPhone" v-else :class="{ 'not-valid' : !isPhoneValid }">Телефона е задължителен</label>
                        <input type="text" id="inquiryPhone" :class="{ 'not-valid-border' : !isPhoneValid }" v-model="request.phone">
                    </div>
                </div>
                <div class="inquiry-input inquiry-form-textarea">
                    <label for="inquiryMessage" v-if="isMessageValid && isMessageLengthValid">Допълнителни уточнения/разяснения по проекта</label>
                    <label for="inquiryMessage" v-else-if="!isMessageLengthValid && isMessageValid" :class="{ 'not-valid' : !isMessageLengthValid }">Допустимата дължина е 1600</label>
                    <label for="inquiryMessage" v-else :class="{ 'not-valid' : !isMessageValid }">Допълнителни уточнения/разяснения по проекта са задължителни</label>
                    <textarea id="inquiryMessage" cols="30" rows="10" :class="{ 'not-valid-border' : !isMessageValid }" v-model="request.message"></textarea>
                </div>

        <div class="captcha--button">
          <!-- <div class="captcha-wrapper" v-if="captcha">
            <p class="captcha--p" v-if="captcha.numOne && captcha.numTwo">
              {{ captcha.numOne }} + {{ captcha.numTwo }} =
            </p>
            <input
              class="captchaSum"
              :class="{ 'not-valid-border': !isCaptchaValid }"
              type="number"
              :min="0"
              oninput="validity.valid || (value='')"
              :step="0.01"
              v-model="request.captchaSum"
            />
          </div> -->

          <button @click="send" class="inquiry-submit">
            <template v-if="isSent">Готово</template>
            <template v-else-if="isLoading && !isSent">Един момент</template>
            <template v-else>Изпрати</template>
          </button>
        </div>
        
            </div>
            <div class="inquiry-success" v-if="isSent">
              <p>Запитването е изпратено успешно!</p>
              <p>Ще се свържем с вас до 48 часа.</p>
            </div>
            <p class="agreement"><span>С изпращането на това запитване вие се съгласявате с&nbsp;</span><router-link class="link" to="/gdpr" target="_blank">Нашата политика за поверителност на потребителските данни</router-link>.</p>
        </div>
    </div>
</template>

<script>
import sendInquiry from "./mixins/sendInquiry.js";
// import captcha from './mixins/captcha.js';
export default {
  mixins: [sendInquiry],
  props: ["solution"],
  data() {
    return {
      loading: false,
      // captcha: "",
    };
  },
  methods: {
    closeInquiry() {
      this.$parent.$emit("close-inquiry");
    },
    send() {
      // this.sendInquiry(" за проект", this.solution, this.captcha);
      this.sendInquiry(" за проект", this.solution);
    },
  },
  // watch: {
  //   rendered() {
  //     if (this.rendered) {
  //       this.captcha = this.getCaptcha();
  //     }
  //   },
  // },
  // mounted() {
  //   this.captcha = this.getCaptcha();
  // },
};
</script>

<style scoped>
.solution-inquiry {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.captcha-wrapper {
  align-items: center;
  display: flex;
}
  .captcha--p {
    font-size: 14px;
    white-space: nowrap;
  }
  .captchaSum {
  background-color: #e9e9e9;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #000;
  font-size: 14px;
  outline: none;
  margin-left: 5px;
  max-width: 50px;
  padding: 5px;
  }
.inquiry {
  align-items: center;
  background-color: #e9e9e9;
  border-radius: 4px;
  -webkit-box-shadow: 0px 60px 80px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 60px 80px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 60px 80px 0px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 30px 100px;
  position: relative;
  width: 1440px;
}
.close-btn {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 40px;
}
.close-x {
  width: 20px;
}
.close-btn:hover {
  background-color: #dfdfdf;
}
.inquiry > h4 {
  color: rgba(0, 0, 0, 0.8);
}
.inquiry > span {
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
}
.inquiry-form {
  margin: 90px 0;
  width: 100%;
}
.inquiry-form-row {
  display: flex;
}
.inquiry-input {
  height: 60px;
  margin: 10px;
  position: relative;
  width: 33.33%;
}
.inquiry-form-textarea {
  height: 110px;
  width: calc(100% - 20px);
}
.inquiry-input input,
.inquiry-input textarea {
  background-color: #e9e9e9;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #000;
  font-size: 16px;
  outline: none;
  padding: 0 25px;
  width: 100%;
  height: 60px;
}
.inquiry-input textarea {
  height: 110px;
  padding: 25px;
  resize: none;
}
.inquiry-input label {
  background-color: #e9e9e9;
  color: #000;
  font-size: 16px;
  left: 15px;
  padding: 0 10px;
  position: absolute;
  top: -9px;
}
.inquiry-submit {
  align-items: center;
  background-color: #000;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 700;
  height: 45px;
  justify-content: center;
  width: 178px;
  z-index: 1;
}
.captcha--button{
    align-items: center;
  bottom: 17.5px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  font-weight: 700;
  height: 45px;
  justify-content: center;
  margin-top: 25px;
  position: absolute;
  right: 110px;
  gap: 15px;
  z-index: 1;
}
.inquiry-submit:hover {
  background-color: #191b1d;
}
.inquiry-success {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 210px;
  justify-content: center;
  margin: 90px 0;
}
.inquiry-success p {
  color: #2b2b2b;
  font-size: 24px;
  text-align: center;
}
.agreement {
  align-items: center;
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ebe8e8+50,f0f0f0+100 */
  background: rgb(255, 255, 255); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(235, 232, 232, 1) 50%,
    rgba(240, 240, 240, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(235, 232, 232, 1) 50%,
    rgba(240, 240, 240, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(235, 232, 232, 1) 50%,
    rgba(240, 240, 240, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f0f0f0',GradientType=0 );
  bottom: 0;
  color: #5b5b5b;
  display: flex;
  font-size: 12px;
  height: 40px;
  left: 0;
  padding: 0 110px;
  position: absolute;
  width: 100%;
}
.link {
  color: #5b5b5b;
  text-decoration: underline;
}
.consultation-right-form-re {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
@media screen and (max-width: 1600px) {
  .inquiry {
    width: 1280px;
  }
  .inquiry-form,
  .inquiry-success {
    margin: 75px 0;
  }
  .inquiry-success {
    height: 190px;
  }
  .inquiry-success p {
    font-size: 20px;
  }
  .inquiry-input,
  .inquiry-input input {
    height: 50px;
  }
  .inquiry-form-textarea,
  .inquiry-input textarea {
    height: 100px;
  }
}
@media screen and (max-width: 1440px) {
  .inquiry {
    width: 1150px;
  }
  .inquiry-form,
  .inquiry-success {
    margin: 50px 0;
  }
  .inquiry-input > label {
    font-size: 14px;
    top: -8px;
  }
  .inquiry-submit {
    font-size: 14px;
  }
}
@media screen and (max-width: 1366px) {
  .inquiry {
    width: 1000px;
  }
  .inquiry > span,
  .inquiry-input > label {
    font-size: 12px;
  }
  .inquiry-submit {
    bottom: 20px;
    height: 40px;
    width: 150px;
  }
  .inquiry-form,
  .inquiry-success {
    margin: 35px 0;
  }
  .inquiry-input,
  .inquiry-input input {
    height: 40px;
  }
  .inquiry-form-textarea,
  .inquiry-input textarea {
    height: 80px;
  }
  .inquiry-input input,
  .inquiry-input textarea {
    font-size: 14px;
  }
  .agreement {
    font-size: 10px;
  }
  .inquiry-success {
    height: 160px;
  }
  .inquiry-success p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .inquiry {
    height: 100%;
    padding: 40px;
    width: 100%;
  }
  .inquiry-form-row {
    flex-direction: column;
  }
  .inquiry-input {
    margin: 10px 0;
    width: 100%;
  }
  .captcha--button{
    position: initial;
    flex-direction: column;
    height: fit-content;
  }
  .inquiry-submit {
    display: flex;
    /* margin: 25px auto 0; */
    position: static;
  }
  .agreement {
    height: 80px;
    flex-direction: column;
    justify-content: center;
    padding: 0 40px;
  }
  .agreement > a,
  .agreement > span {
    text-align: center;
  }
}
@media screen and (max-width: 600px) {
  .inquiry {
    padding: 20px;
  }
}
@media screen and (max-width: 440px) {
  .inquiry > span,
  .inquiry-input > label {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SolutionInquiry.vue